<template>
  <Webview>
    <template v-if="currentPage === 'login'">
      <div class="login_scroll">
        <div class="login_frame">
          <div class="login_ctn">
            <div class="logo">
              <img src="@img/logo_login.svg">
            </div>
            <div class="login_input">
              <div class="login_box">
                <template v-for="(item, key) in form">
                  <Control :passData="item" :update="update" :check="check"></Control>
                </template>
                <div class="submit_ctn">
                  <div class="main_btn _main" @click="submit">登入</div>
                  <div class="main_btn _plain" @click="toPage('register')">註冊</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- Otp -->
    <template v-else-if="currentPage === 'login_otp'">
      <Otp :email="email" :back="()=>toPage('current')" :submit="login" />
    </template>
  </Webview>
</template>

<script>
//api
import { sendOtp } from "@/api/auth";

export default {
  mixins: [
    require("@mix/form").default,
    require("@mix/notifyToken").default, //幫 qs/store 存取 notifyToken
    require("./mixins/formData").default
  ],
  computed: {
    currentPage() { return this.$route.name }
  },
  methods: {
    toPage(type) {
      switch (type) {
        case "otp": {
          this.$router.push({ name: "login_otp" });
          break; //輸入 email 後, 跳轉至 otp 頁面
        }
        case "current": this.$router.push({ name: "login" }); break; //在 login_otp 頁面時,按下返回回到 login 頁面

        case "register": this.$router.push({ name: "register" }); break; //點擊 註冊 後, 跳轉至 register 頁面
      }
    },
    submit() {
      this.checkAll();
      if (!this.isAllValid) return false;
      this.sendOtp();
    },
    sendOtp() {
      sendOtp(this.email).then(() => {
        MESSAGE("s", "資料正確，驗證碼已發送至會員電子郵件信箱");

        this.toPage("otp");
      }).catch(error => {
        NOTIFICATION("e", error?.message || this.$tp("slot.failed", { label: "發送驗證碼" }));
      })
    },
    async login(otp) {
      await this.$store.dispatch("OtpLogin", { email: this.email, otp: otp });

      //不要動, 只有一般 .vue 才有 this
      this.$router.replace({ path: "/channel" });
    }
  }
}
</script>

<style lang="scss" scoped>
.login_scroll {
  position: relative;
  height: 100%;
  background-color: $main;
  overflow-y: auto;
  .login_frame {
    min-height: 100%;
    display: flex;
  }
  .login_ctn {
    min-height: 78vh;
    width: 100%;
    align-self: flex-end;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .logo {
    padding: 0 $main_P;
    margin-bottom: 1rem;
    > img {
      max-width: 16.7rem;
      margin: 0 auto;
    }
  }
  .login_input {
    background-color: #ffffff;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    padding: 3rem $main_P;
  }
  .submit_ctn {
    margin-top: 2rem;
    .main_btn._plain {
      margin-top: 0.8rem;
      box-shadow: none;
    }
  }
}
</style>
